exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1R0nUw4Af558ouxlFCi92X{width:72px;height:72px;line-height:72px}html[dir] ._1R0nUw4Af558ouxlFCi92X{border-radius:50%;text-align:center}._16PkdYKSeDqkxFVjy-7G4{font-size:24px}", ""]);
// Exports
exports.locals = {
	"cardIconContainer": "_1R0nUw4Af558ouxlFCi92X",
	"cardIcon": "_16PkdYKSeDqkxFVjy-7G4"
};